import React, { Component } from 'react';
import countapi from 'countapi-js';

class VisitArticoli extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
    countapi.visits('articoli').then((result) => {
      console.log(result)
      this.setState({ visiteArticoli: result.value });
    });
  }

  render() {

    return (
      <span style={{fontSize: '18px', marginBottom: '-20.5px'}} title="Numero delle visite sulla pagina 'Articoli'">(👁 {this.state.visiteArticoli})</span>
    );

  }
}

export default VisitArticoli;